export default "__VITE_ASSET__br_6lD7x__"